enum FieldOptionViewType {
  SINGLE_COLUMN = "SINGLE_COLUMN",
  MULTIPLE_COLUMN = "MULTIPLE_COLUMN"
}

export default FieldOptionViewType;
